import { createSlice } from "@reduxjs/toolkit";
import { addProvidersDetailsAPI, fetchAddProvidersCertifiedSpecialty, fetchAddProvidersLicenseTypes } from "./AddProvidersActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";



const addProviderLicenseTypeSuggestions = createSlice({
  name: "addProviderLicenseTypeSuggestions",
  initialState: {
    isAddProvidersLicenseTypeLoading: false,
    addProvidersLicenseTypeData: [],
    addProvidersLicenseTypeError: null,
    addProvidersLicenseTypeErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddProvidersLicenseTypes.pending, (state) => {
        state.isAddProvidersLicenseTypeLoading = true;
        state.addProvidersLicenseTypeError = null;
      })
      .addCase(fetchAddProvidersLicenseTypes.fulfilled, (state, action) => {
        state.isAddProvidersLicenseTypeLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.addProvidersLicenseTypeError = false;
            state.addProvidersLicenseTypeData = [];
          }
          else {
            state.addProvidersLicenseTypeError = true;
            state.addProvidersLicenseTypeErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.addProvidersLicenseTypeError = false;
          state.addProvidersLicenseTypeData = action.payload.data.data.licenseTypeResponseDTO;
        }
      })
      .addCase(fetchAddProvidersLicenseTypes.rejected, (state, action) => {
        state.isAddProvidersLicenseTypeLoading = false;
        state.addProvidersLicenseTypeError = action.error.message;
      });
  },
});


const addProvidersCertifiedSpecialty = createSlice({
  name: "addProvidersCertifiedSpecialty",
  initialState: {
    isCertifiedSpecialtyLoading: false,
    addProvidersCertifiedSpecialty: [],
    certifiedSpecialtyError: null,
    certifiedSpecialtyErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddProvidersCertifiedSpecialty.pending, (state) => {
        state.isCertifiedSpecialtyLoading = true;
        state.certifiedSpecialtyError = null;
      })
      .addCase(fetchAddProvidersCertifiedSpecialty.fulfilled, (state, action) => {
        state.isCertifiedSpecialtyLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.certifiedSpecialtyError = false;
            state.addProvidersCertifiedSpecialty = [];
          }
          else {
            state.certifiedSpecialtyError = true;
            state.certifiedSpecialtyErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.addProvidersCertifiedSpecialty = action.payload.data.data.specialtyResponseDTO;
        }
      })
      .addCase(fetchAddProvidersCertifiedSpecialty.rejected, (state, action) => {
        state.isCertifiedSpecialtyLoading = false;
        state.certifiedSpecialtyError = action.error.message;
      });
  },
});




const addProvidersDetails = createSlice({
  name: "addProvidersDetails",
  initialState: {
    isAddProvidersDataLoading: false,
    addProvidersDetails: {},
    addProvidersError: null,
    addProvidersErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addProvidersDetailsAPI.pending, (state) => {
        state.isAddProvidersDataLoading = true;
        state.addProvidersError = null;
      })
      .addCase(addProvidersDetailsAPI.fulfilled, (state, action) => {
        state.isAddProvidersDataLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.addProvidersError = false;
            state.addProvidersDetails = {};
          }
          else {
            state.addProvidersError = true;
            state.addProvidersErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.addProvidersError = false;
          state.addProvidersDetails = action.payload.data.data.providerDto;
        }
      })
      .addCase(addProvidersDetailsAPI.rejected, (state) => {
        state.isAddProvidersDataLoading = false;
        state.addProvidersError = "Something Went Wrong!. Please try again later.";
      });
  },
});



export const addProvidersLicenseTypesReducer = addProviderLicenseTypeSuggestions.reducer;
export const addProvidersCertifiedSpecialtyReducer = addProvidersCertifiedSpecialty.reducer;
export const { addProvider } = addProvidersDetails.actions;
export const addProvidersDetailsReducer = addProvidersDetails.reducer;